<template>
    <div class="my-body" style="padding-bottom:50px;">
        <div class="message-top-div" v-if="showFloatMessage"></div>
        <div class="float-message" v-if="showFloatMessage"><span>●</span>报销凭证：可到机场服务台，打印行程单</div>
        <div class="start-destination-class" >
            <div class="filghts-line-text" style="color: #FFFFFF;">
                <span>{{departCity}}</span>
                <img class="min-line-img" src="../../../assets/flights/i_icon_arrows_right3_32px_@2x.m.png"/>
                <span>{{arriveCity}}</span>
            </div>
        </div>
        <div class="padding-div" style="padding-top:0;">
            <div class="head-tab-div">
                <div class="flex jus-con-between ali-ite-center content-padding radius-top font-class head-child-div">
                    <div>
                        <span class="margin-right-10">{{leaveTimeMinutes}}</span>
                        <span class="margin-right-10">周{{weeks[leaveTimeDay]}}</span>
                        <span>{{flightDuration}}</span>
                    </div>
                    <div class="flex jus-con-start ali-ite-center" @click="refundModalVisible = true">退改规则<img style="width:0.7em;height:0.7em;margin-left:0.25em;" src="../../../assets/flights/o_icon_Expand_right1_20px_@2x.m.png"/></div>
                </div>
                <div class="content-padding radius-bottom">
                    <div class="time-tab">
                        <div class="start-time">
                            <div class="font-big color-2E3033">{{fromAirport}}{{fromAirportTower}}</div>
                        </div>
                        <div class="time-line-img">
                          <div style="font-size: 10px;text-align: center;color: #666666;">{{flightDuration}}</div>
                          <img src="../../../assets/flights/i_icon_arrow_150px_@2x.m.png" />
                          <div v-if="stopType === '2'" class="turn-to-stop">
                            <span style="color: #1890ff">停</span>
                            <span>{{stopCitys}}</span>
                          </div>
                          <div v-if="stopType === '3'" class="turn-to-stop">
                            <span style="color: #1890ff">转</span>
                            <span>{{stopCitys}}</span>
                          </div>
                          <div v-if="stopType === '4'" class="turn-to-stop">
                            <span style="color: #1890ff">通程</span>
                            <span>{{stopCitys}}</span>
                          </div>
                        </div>
                        <div class="arrive-time">
                            <div class="font-big color-2E3033">{{toAirport}}{{toAirportTower}}</div>
                        </div>
                    </div>
                    <div class="flights-tab-end" >
                        <div>
                          <div class="flights-img-logo" :style="{backgroundPosition:('0 -'+logoPosition+'px')}" ></div>
                          <div>{{ezmName}}{{flightNum}}</div>
                        </div>
                        <div>
                            <img class="min-img-title" src="../../../assets/flights/airplane.png" />
                            <div>机型：{{plane}}</div>
                        </div>
                        <div>
                            <img class="min-img-title" v-if="!meal" src="../../../assets/flights/no-food.png" />
                            <img class="min-img-title" v-if="!!meal" src="../../../assets/flights/food.png" />
                            <div v-if="!meal">无餐食</div>
                            <div v-if="!!meal">有餐食</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="message-text-div flex jus-con-start ali-ite-end">
                <!-- <img style="width:1.25em;height:1.25em;margin-right:0.25em;" src="../../../assets/flights/i_icon_time3_26px_@2x.m.png" /> -->
                <div>支持{{cardTypeList.map(item => item.dictLabel).join('、')}}购买，{{supportChildren ? '支持儿童购买' : '不支持儿童购买'}}</div>
            </div>
        </div>
        <div class="padding-div" style="padding-top:0;">
            <div class="border-div" style="overflow-x:hidden;">
                <div class="flex jus-con-start ali-ite-center margin-div">
                    <div class="font-large">选择乘机人</div>
                    <div class="font-x-small" style="color: #8A8F99;font-size:12px;margin-left:0.5em;">成人{{adultAmount}}人&nbsp;</div>
                    <div class="font-x-small" style="color: #8A8F99;font-size:12px;margin-left:0.5em;" v-if="childAmount !== 0 && supportChildren">儿童{{childAmount}}人&nbsp;</div>
                    <div class="font-x-small" style="color: #8A8F99;font-size:12px;margin-left:0.5em;" v-if="infantAmount !== 0">婴儿{{infantAmount}}人&nbsp;</div>
                </div>
                <div style="padding:15px 0;margin: 0 15px;">
                    <div class="flex jus-con-start ali-ite-start row-four" style="flex-wrap: wrap;">
                        <div v-for="(item,index) in passengersList" :key="index" class="blue-border flex jus-con-center ali-ite-center border-height" :style="{border:(item.checked?'1px solid #4380FF':'1px solid transparent')}">
                            <div class="mess-tab mess-tab-other">
                                <div class="mess-tab-name flex jus-con-center ali-ite-center max-two-row" :style="{height:(item.isFinish?'60px':'auto')}"  @click="passengersListClick(index)" >{{item.name}}</div>
                                <div v-show="!item.isFinish" class="mess-tab-ts" style="margin-top: 10px;"  @click="updatePassengersOraginMessage(index)">补全信息</div>
                            </div>
                        </div>

                        <div v-show="passengersSourceList.length<=7" class="mess-tab flex jus-con-center ali-ite-center border-height" @click="gotoAddPage">
                            <div class="mess-tab-name">+新增</div>
                        </div>
                        <div v-show="passengersSourceList.length>7" class="mess-tab flex jus-con-center ali-ite-center border-height" @click="moreListPage">
                            <div class="mess-tab-name">更多</div>
                        </div>
                    </div>

                </div>
                <div v-for="(item,index) in passengersListOther" :key="index" >
                  <div v-if="item.checked===true" class="margin-bottom flex jus-con-between ali-ite-center">
                      <div class="flex jus-con-start ali-ite-center">
                          <div class="img-clear-btn"><img src="../../../assets/flights/o_icon_delete_40px_@2x.m.png"  @click="deleteOtherList(index,item.id)"/></div>
                          <div>
                              <div class="flex jus-con-start ali-ite-center">
                                  <div class="tab-name">{{item.name}}</div>
                                  <div class="tab-type">{{item.touristType}}</div>
                                  <div class="oneself-tab" v-if="item.isSelf==='1'">本人</div>
                              </div>
                              <div class="tab-idcard">{{item.certTypeValue}} {{(item.idCard===null||item.idCard==='')?'空':item.idCard}}</div>
                          </div>
                      </div>
                      <div class="tab-update flex jus-con-center ali-ite-center" @click="updatePassengersMessage(index)">编辑</div>
                  </div>
                </div>
                <div class="margin-div" style="border-bottom:1px solid #E7EBF3;"></div>
                <div class="div-width">
                    <van-field
                        v-model="name"
                        value=""
                        label="联系人"
                        placeholder="请输入姓名"
                        input-class="input-class"
                        :border="false"
                        @blur="(e) => handleBlurContactItem(e, 'name')"
                    />
                    <van-field
                        v-model="tel"
                        type="number"
                        value=""
                        label="手机号"
                        placeholder="请输入您的手机号码"
                        input-class="input-class"
                        :border="false"
                        @blur="(e) => handleBlurContactItem(e, 'tel')"
                    />
                </div>
            </div>
        </div>
        <div class="padding-div message-text">
          点击提交订单表示已阅读并同意免责条款、费用扣除、退保等在内的重要事项，其中包括
          《<span class="color-blue" @click="handleJumping('https://privacy.ganyoutong.cn/Statement_of_Rights_and_Responsibilities.html')">权责声明</span>》
          《<span class="color-blue" @click="handleJumping('https://privacy.ganyoutong.cn/Disclaimer.html')">免责声明</span>》
          《<span class="color-blue" @click="handleJumping('https://privacy.ganyoutong.cn/Booking_instructions.html')">预订须知</span>》
          《<span class="color-blue" @click="handleJumping('https://privacy.ganyoutong.cn/battery-rule.html')">锂电池及危险品乘机须知</span>》
          《<span class="color-blue" @click="handleJumping('https://privacy.ganyoutong.cn/netProtocol.html')">机票预订网络服务合同</span>》
        </div>
        <div class="red-message"><span>●</span>报销凭证：可到机场服务台，打印行程单</div>
        <div class="bg-view-div" v-show="showDetail" @click="showDetail = false" >

        </div>
        <div class="mx-body-div" :style="{display:showDetail?'inherit':'none',height:showDetail?'auto':'0'}">
            <div class="mx-item-div">
                <div>成人票</div>
                <div class="mx-right-item"><div class="mx-price">￥{{adultPriceMap.price}}</div><div class="mx-num">x{{adultAmount}}人</div></div>
            </div>
           <div class="mx-item-div">
                <div>机建 + 燃油（成人）</div>
                <div class="mx-right-item"><div class="mx-price">￥{{adultPriceMap.fee}}</div><div class="mx-num">x{{adultAmount}}份</div></div>
            </div>
            <template v-if="childAmount !== 0 && supportChildren">
              <div class="mx-item-div">
                  <div>儿童票</div>
                  <div class="mx-right-item"><div class="mx-price">￥{{childPriceMap.price}}</div><div class="mx-num">x{{childAmount}}人</div></div>
              </div>
              <div class="mx-item-div">
                  <div>燃油（儿童）</div>
                  <div class="mx-right-item"><div class="mx-price">￥{{childPriceMap.fee}}</div><div class="mx-num">x{{childAmount}}份</div></div>
              </div>
             </template>
            <template v-if="infantAmount !== 0">
              <div class="mx-item-div">
                  <div>婴儿票</div>
                  <div class="mx-right-item"><div class="mx-price">￥{{infantPriceMap.price}}</div><div class="mx-num">x{{infantAmount}}人</div></div>
              </div>
              <div class="mx-item-div">
                  <div>婴儿服务费</div>
                  <div class="mx-right-item"><div class="mx-price">￥{{infantPriceMap.fee}}</div><div class="mx-num">x{{infantAmount}}份</div></div>
              </div>
             </template>
        </div>
        <div class="bottom-btn-tab">
            <div class="price-show">
                <div class="price-char">￥</div>
                <div>{{summaryPrice.toFixed(2)}}</div>
            </div>
            <div class="flex jus-con-end ali-ite-center" >
                <div class="mx-div flex jus-con-start ali-ite-center" @click="changeShowDetail">
                    <div class="mx-show-text">明细</div>
                    <img class="mx-img" v-show="!showDetail" src="../../../assets/flights/o_icon_Expand_upward_20px_@2x.m.png"/>
                    <img class="mx-img" v-show="showDetail" src="../../../assets/flights/o_icon_Expand_down2_20px_@2x.m.png"/>
                </div>
                <div class="btn-blue" @click="ticketReservation">提交订单</div>
            </div>
        </div>
        <jlkj-popup ref="popup" v-show="windowShow" :message="thisMessage" :type="'center'"></jlkj-popup>
        <div v-show="finishLoadShow" class="finish-load-class">
            <van-loading color="#1989fa" />
        </div>
        <flights-refund-policy v-model="refundModalVisible" :baggageRuleInfos="baggageRuleInfos" :tgqInfos="tgqInfos"></flights-refund-policy>
    </div>
</template>
<script>
import {Notify} from "vant";
import dayjs from 'dayjs';
import JlkjPopup from "../../../components/jlkj-popup.vue";
import FlightsRefundPolicy from '../../../components/flights-refund-policy.vue';
const today = dayjs();

export default {
    components:{JlkjPopup, FlightsRefundPolicy},
    data(){
        const {
          from,
          to,
          supplierId,
          fromAirport,
          toAirport,
          fromAirportTower,
          toAirportTower,
          flightType,
          innerTravelFlag,
          sys,
          flightNum,
          leaveTime,
          arriveTime,
          cabin,
          publishPrice,
          departCity,
          arriveCity,
          ezmName,
          plane,
          isShare,
          logoPosition,
          flightDuration,
          stopCitys,
          stopType,
          meal,
        } = this.$route.query;
        return {
            name:'',
            tel:'',
            itemIndex:0,
            placeModel:'',
            hasFood:true,
            imageUrl:'',
            start:'',
            destination:'',
            showDetail:false,
            showFloatMessage:true,
            passengersList:[],
            passengersListOther:[],
            passengersSourceList:[],
            windowShow:false,
            thisMessage:"",
            finishLoadShow:false,
            ticketIsRun:false,

            // New
            loading: false,
            // 出发机场代码
            from,
            // 到达机场代码
            to,
            supplierId,
            // 出发机场名称
            fromAirport,
            // 到达机场名称
            toAirport,
            fromAirportTower,
            toAirportTower,
            flightType,
            innerTravelFlag,
            sys,
            flightNum,
            leaveTime,
            arriveTime,
            cabin,
            publishPrice,
            // 出发城市
            departCity,
            // 到达城市
            arriveCity,
            ezmName,
            plane,
            isShare: isShare === 'true',
            logoPosition,
            flightDuration,
            stopCitys,
            stopType,
            meal: meal === 'true',
            checkParam: '',
            businessExt: '',
            weeks: ['日', '一', '二', '三', '四', '五', '六'],
            // 支持的证件类型
            cardTypeList: [],
            // 1 "单程"
            // 2 "往返包"
            // 3 "中转包"
            // 5 "往返拼接"
            // 6 "中转拼接"
            // 7 "中转进往返拼接"
            airlineType: '1',
            // 下单校验参数
            bookingTag: '',
            // 行程报价信息
            tripInfos: [],
            baggageRuleInfos: {}, // 行李额
            tgqInfos: {}, // 退改签
            refundModalVisible: false,
            timer: null,
        }
    },
    computed: {
      leaveTimeMinutes() {
        return dayjs(this.leaveTime).format('MM-DD');
      },
      leaveTimeDay() {
        return dayjs(this.leaveTime).day();
      },
      // 是否支持儿童
      supportChildren: function() {
        return this.tripInfos.some(item => item.clientBookingResult.priceInfo.childPriceType === 1 || item.clientBookingResult.priceInfo.childPriceType === 3)
      },
      adultAmount: function() {
        return this.passengersListOther.length - this.childAmount - this.infantAmount;
      },
      adultPriceMap: function () {
        return this.tripInfos.reduce(
          (obj, curr) => {
            obj.remaining += Number(
              curr.clientBookingResult.seat.adultCabinNumber.slice(-1),
            );
            obj.price += curr.clientBookingResult.priceInfo.priceTag.ADU.reduce(
              (sum, adult) => sum + adult.buyPrice,
              0,
            );
            obj.fee += (Number(curr.clientBookingResult.priceInfo.planeTax) + Number(curr.clientBookingResult.priceInfo.yq));
            return obj;
          },
          { remaining: 0, price: 0, fee: 0 },
        );
      },
      childAmount: function() {
        return this.passengersListOther.filter(passenger => {
          const birthday = passenger.certType === '1' && passenger.idCard ? `${passenger.idCard.slice(6, 10)}-${passenger.idCard.slice(10, 12)}-${passenger.idCard.slice(12, 14)}` : passenger.birthday;
          const diffYears = today.diff(dayjs(birthday), 'y');
          if (2 <= diffYears && diffYears < 12) {
            return true;
          } else {
            return false;
          }
        }).length;
      },
      childPriceMap: function() {
        return this.tripInfos.reduce(
          (obj, curr) => {
            obj.remaining += Number(
              curr.clientBookingResult.seat.childCabinNumber.slice(-1),
            );
            obj.price += curr.clientBookingResult.priceInfo.priceTag.CHI.reduce(
              (sum, adult) => sum + adult.buyPrice,
              0,
            );
            obj.fee += Number(curr.clientBookingResult.priceInfo.childPlaneTax);
            return obj;
          },
          { remaining: 0, price: 0, fee: 0 },
        );
      },
      infantAmount: function() {
        return this.passengersListOther.filter(passenger => {
          const birthday = passenger.certType === '1' && passenger.idCard ? `${passenger.idCard.slice(6, 10)}-${passenger.idCard.slice(10, 12)}-${passenger.idCard.slice(12, 14)}` : passenger.birthday;
          const diffYears = today.diff(dayjs(birthday), 'y');
          const diffDays = today.diff(dayjs(birthday), 'd');
          if (14 <= diffDays && diffYears < 2) {
            return true;
          } else {
            return false;
          }
        }).length;
      },
      infantPriceMap: function() {
        return this.tripInfos.reduce(
          (obj, curr) => {
            obj.remaining += Number(
              curr.clientBookingResult.seat.infantCabinNumber.slice(-1),
            );
            obj.price += curr.clientBookingResult.priceInfo.priceTag.INF.reduce(
              (sum, adult) => sum + adult.buyPrice,
              0,
            );
            obj.fee += Number(curr.clientBookingResult.priceInfo.infServerFee);
            return obj;
          },
          { remaining: 0, price: 0, fee: 0 },
        );
      },
      summaryPrice: function() {
        try {
          return this.adultAmount * (this.adultPriceMap.price + this.adultPriceMap.fee) +
            this.childAmount * (this.childPriceMap.price + this.childPriceMap.fee) +
            this.infantAmount * (this.infantPriceMap.price + this.infantPriceMap.fee);
        } catch (error) {
          console.log(error.message);
          return 0;
        }
      },
    },
    created() {
      this.checkParam = localStorage.getItem('check_param');
      this.businessExt = localStorage.getItem('business_ext');
      this.handleCheckingOrder();
    },
    mounted(){
        // this.innerTravelFlag=this.$route.query.type;
        // this.supplierId=this.$route.query.supplierId;
        // this.from=this.$route.query.from;
        // this.to=this.$route.query.to;
        // let tempBack=sessionStorage.getItem('flights-passenger-add-back');
        // if(tempBack==='1'){
        //     this.goBack();
        //     this.selectedDataChange();
        //     return;
        // }

        let tempBack=sessionStorage.getItem('flights-passenger-add-back');
        if(tempBack==='1'){
            this.goBack();
            // this.selectedDataChange();
            ////return;
        }
        // else{
        //     this.selectedDataChange();
        // }
        this.getPassengersList();
        this.timer = setInterval(() => {
          this.handleCheckingOrder();
        }, 300000);
        let tempContact = sessionStorage.getItem('flightContact') ? JSON.parse(sessionStorage.getItem('flightContact')) : {};
        if (JSON.stringify('JSON.parse') !== '{}') {
            this.name = tempContact.name;
            this.tel = tempContact.tel;
        }
    },
    activated(){

        let tempBack=sessionStorage.getItem('flights-passenger-add-back');
        if(tempBack==='1'){
           this.selectedDataChange();
        }
    },
    destroyed(){
        if(sessionStorage.getItem('flights-passenger-add-back')==='0'){
            sessionStorage.setItem('flights-passenger-add-data','');
        }
        clearInterval(this.timer);
    },
    methods:{
      handleCheckingOrder() {
        const toast = this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
        if (this.checkParam && this.businessExt) {
          this.$API.flights
            .getCheckResultForOrdering({
              checkParam: this.checkParam,
              flightType: Number(this.flightType),
              businessExt: this.businessExt,
              supplierId: this.supplierId,
              innerTravelFlag: this.innerTravelFlag,
              sys: this.sys,
            })
            .then((res) => {
              toast.clear();
              if (res.code < 300 && res.data) {
                this.cardTypeList = res.data.cardTypeList.filter(item => item.dictValue === '1');
                this.bookingTag = res.data.bookingTag;
                this.airlineType = res.data.type;
                this.tripInfos = res.data.tripInfos;
                this.baggageRuleInfos = res.data.tripInfos ? res.data.tripInfos[0].baggageRuleInfos : {}
                this.tgqInfos = res.data.tripInfos ? res.data.tripInfos[0].tgqInfos : {}
              } else {
                Notify({ type: 'danger', message: res.msg });
              }
            })
            .catch((err) => {
              toast.clear();
              this.$toast.fail('下单校验失败');
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
              console.log(err.message);
            })
        } else {
          toast.clear();
        }
      },
        //已点击联系人的数据的缓存数据在复制给该页面
        selectedDataChange(){
            if(sessionStorage.getItem('tempSelectPassenager')!==null){
                let tempList=JSON.parse(sessionStorage.getItem('tempSelectPassenager'));
                // 除去不支持儿童的数据
                this.passengersListOther=this.passengersSourceList.filter((item => item.touristType === '成人' || (this.supportChildren && item.touristType === '儿童'))).filter((item)=>  tempList.some(select => select.id === item.id)).map(item => ({ ...item, checked: true }));
            }
            for(let i=0;i<this.passengersList.length;i++){
                this.passengersList[i].checked=false;
                for(let j=0;j<this.passengersListOther.length;j++){
                    if(this.passengersList[i].id===this.passengersListOther[j].id){
                        this.passengersList[i].checked=true;
                    }
                }
            }
        },
        //将之前的该页面data重新复制给该页面
        goBack:function(){
            let tempData=JSON.parse(sessionStorage.getItem('flights-passenger-add-data'));
            if(tempData!==null){
                for(let key in tempData){
                    if(typeof tempData[key]==='object'){
                        this[key]=JSON.parse(JSON.stringify(tempData[key]));
                    }else{
                        this[key]=tempData[key];
                    }
                }
            }
            sessionStorage.setItem('flights-passenger-add-back','0');
        },
        changeShowDetail:function(){
           if(this.showDetail){
               this.showDetail=false;
           }else{
               this.showDetail=true;
           }
        },
        gotoAddPage:function(){
            let query={
                type:'add'
            }

            this.setTempPassengerListOther();

            sessionStorage.setItem('tempMainSelectPassenager',JSON.stringify(this.passengersList));

            sessionStorage.setItem('tempSelectPassenager',JSON.stringify(this.passengersListOther));
            sessionStorage.setItem('flights-passenger-add-data',JSON.stringify(this.$data));
            sessionStorage.setItem('flights-passenger-add-back','1');
            this.$router.push({
                path: './personal-information',
                query:query
            })

        },
        theChangeSelectSessionStorage(){
            sessionStorage.setItem('tempMainSelectPassenager',JSON.stringify(this.passengersList));
            sessionStorage.setItem('tempSelectPassenager',JSON.stringify(this.passengersListOther));
        },
        moreListPage:function(){
            // let tempPassengersListOther={};
            // for(let i=0;i<this.passengersListOther.length;i++){
            //     if(this.passengersListOther[i].checked){
            //         tempPassengersListOther[this.passengersListOther[i].id]=true;
            //     }
            // }
            // sessionStorage.setItem('tempPassengersListOther',JSON.stringify(tempPassengersListOther));
            this.setTempPassengerListOther();

            sessionStorage.setItem('tempMainSelectPassenager',JSON.stringify(this.passengersList));

            sessionStorage.setItem('flights-passenger-add-data',JSON.stringify(this.$data));
            sessionStorage.setItem('flights-passenger-add-back','1');
            this.$router.push({
                path: './passengers-list',
                query: {

                }
            })
        },
        setTempPassengerListOther(){

            let tempPassengersListOther={};
            for(let i=0;i<this.passengersListOther.length;i++){
                if(this.passengersListOther[i].checked){
                    tempPassengersListOther[this.passengersListOther[i].id]=true;
                }
            }
            sessionStorage.setItem('tempPassengersListOther',JSON.stringify(tempPassengersListOther));
        },

        updatePassengersMessage:function(index){
            let passengersListOther=this.passengersList.filter((item)=>{return item.id===this.passengersListOther[index].id})[0];
            let query = {};
            if (passengersListOther) {
                query={
                    id:passengersListOther.id,
                    name:passengersListOther.name,
                    surname:passengersListOther.surname,
                    givenName:passengersListOther.givenName,
                    nationality:passengersListOther.nationality,
                    type:'update',
                    idCardNowIndex:passengersListOther.certType,
                    certNo:passengersListOther.idCard,
                    expireDate:passengersListOther.expireDate,
                    birthday:passengersListOther.birthday,
                    mobile:passengersListOther.mobile,
                    sex:passengersListOther.sex,
                }
            } else {
                query={
                    id:this.passengersListOther[index].id,
                    name:this.passengersListOther[index].name,
                    surname:this.passengersListOther[index].surname,
                    givenName:this.passengersListOther[index].givenName,
                    nationality:this.passengersListOther[index].nationality,
                    type:'update',
                    idCardNowIndex:this.passengersListOther[index].certType,
                    certNo:this.passengersListOther[index].idCard,
                    expireDate:this.passengersListOther[index].expireDate,
                    birthday:this.passengersListOther[index].birthday,
                    mobile:this.passengersListOther[index].mobile,
                    sex:this.passengersListOther[index].sex,
                }
            }
            
            sessionStorage.setItem('flights-passenger-add-data',JSON.stringify(this.$data));
            sessionStorage.setItem('flights-passenger-add-back','1');
            this.$router.push({
                path: './personal-information',
                query: query
            })
        },
        updatePassengersOraginMessage:function(index){
            let query={
                id:this.passengersList[index].id,
                name:this.passengersList[index].name,
                surname:this.passengersList[index].surname,
                givenName:this.passengersList[index].givenName,
                nationality:this.passengersList[index].nationality,
                type:'update',
                idCardNowIndex:this.passengersList[index].certType,
                certNo:this.passengersList[index].certNo,
                expireDate:this.passengersList[index].expireDate,
                birthday:this.passengersList[index].birthday,
                mobile:this.passengersList[index].mobile,
            }
            sessionStorage.setItem('flights-passenger-add-data',JSON.stringify(this.$data));
            sessionStorage.setItem('flights-passenger-add-back','1');
            this.$router.push({
                path: './personal-information',
                query: query
            })
        },
        getPassengersList:function(){

            let tempBack=sessionStorage.getItem('flights-passenger-add-back');
            let params={
                isTourist:1,
                pageNum:0,
                pageSize:20
            };
            let data={
                // certType:"1,2"
                certTypeList:['1','2']
            };
            this.$API.flights.getPassengerList(params,data)
            .then((res)=>{
                if(res.code===200){
                    if(tempBack==='0'){
                        this.passengersList=[];
                        this.passengersSourceList=res.data.frequentContact;
                    }else if(tempBack!=='1'){
                        this.passengersSourceList=res.data.frequentContact;
                    }

                    this.passengersList=[];

                    this.selectedDataChange();

                    let passenagerCheckedObj=sessionStorage.getItem('tempMainSelectPassenager')?JSON.parse(sessionStorage.getItem('tempMainSelectPassenager')):[];
                    let passenagerCheckedObjByListPage=sessionStorage.getItem('tempSelectPassenager')?JSON.parse(sessionStorage.getItem('tempSelectPassenager')):[];

                    for(let i=0;i<res.data.frequentContact.length;i++){
                        if(i<7){
                            console.log('乘机人信息',res.data.frequentContact[i])
                            this.passengersList.push(res.data.frequentContact[i]);
                            this.passengersList[this.passengersList.length-1]['index']=i;

                            let checked=false;
                            let checkedByList=false;

                            checked=passenagerCheckedObj.filter((item)=>{
                                return item.checked&&(item.id===res.data.frequentContact[i]['id']);
                            }).length>0?true:false;

                            checkedByList=passenagerCheckedObjByListPage.filter((item)=>{
                                return item.checked&&(item.id===res.data.frequentContact[i]['id']);
                            }).length>0?true:false;

                            this.passengersList[this.passengersList.length-1]['checked']=checked||checkedByList;

                            let isFinish=false;

                            switch(this.passengersList[this.passengersList.length-1].certType){
                                case '1':
                                    if(
                                        this.passengersList[this.passengersList.length-1].name!==null&&
                                        this.passengersList[this.passengersList.length-1].name!==''&&
                                        this.passengersList[this.passengersList.length-1].nationality!==null&&
                                        this.passengersList[this.passengersList.length-1].nationality!==''&&
                                        this.passengersList[this.passengersList.length-1].mobile!==null&&
                                        this.passengersList[this.passengersList.length-1].mobile!==''&&
                                        this.passengersList[this.passengersList.length-1].idCard!==null&&
                                        this.passengersList[this.passengersList.length-1].idCard!==''
                                    ){
                                        isFinish=true;
                                    }
                                    break;
                                case '2':
                                    if(
                                        this.passengersList[this.passengersList.length-1].name!==null&&
                                        this.passengersList[this.passengersList.length-1].name!==''&&
                                        this.passengersList[this.passengersList.length-1].nationality!==null&&
                                        this.passengersList[this.passengersList.length-1].nationality!==''&&
                                        this.passengersList[this.passengersList.length-1].mobile!==null&&
                                        this.passengersList[this.passengersList.length-1].mobile!==''&&
                                        this.passengersList[this.passengersList.length-1].idCard!==null&&
                                        this.passengersList[this.passengersList.length-1].idCard!==''&&
                                        this.passengersList[this.passengersList.length-1].expireDate!==null&&
                                        this.passengersList[this.passengersList.length-1].expireDate!==''&&
                                        this.passengersList[this.passengersList.length-1].givenName!==null&&
                                        this.passengersList[this.passengersList.length-1].givenName!==''&&
                                        this.passengersList[this.passengersList.length-1].surname!==null&&
                                        this.passengersList[this.passengersList.length-1].surname!==''&&
                                        this.passengersList[this.passengersList.length-1].birthday!==null&&
                                        this.passengersList[this.passengersList.length-1].birthday!==''

                                    ){
                                        isFinish=true;
                                    }
                                    break;
                                default:
                                    break;
                            }
                            this.passengersList[this.passengersList.length-1]['isFinish']=isFinish;
                        }
                    }

                }else{

                }

                // 除去不支持儿童的数据
                this.passengersList = this.passengersList.map(item => ({
                  ...item,
                  checked: this.passengersListOther.some(other => other.id === item.id),
                }))
            })
            .catch((err)=>{
            })
        },
        passengersListClick:function(index){
          const target = this.passengersList[index];
          if (!this.supportChildren && target.touristType === '儿童') {
            Notify({ message: '此机票产品暂不支持儿童购买', type: 'danger' });
            return;
          }
          if(target.checked) {
            const index = this.passengersListOther.findIndex(item => item.id === target.id);
            if (!!~index) {
              this.passengersListOther.splice(index,1);
            }
          } else {
            this.passengersListOther.push(target);
          }
          target.checked = !target.checked;
          this.theChangeSelectSessionStorage();
          this.$forceUpdate();
        },
        deleteOtherList:function(index,id){

            this.passengersListOther.splice(index,1);
            // if(this.passengersList[originIndex]!==undefined){
            //     this.passengersList[originIndex]['checked']=false;
            // }
            for(let i=0;i<this.passengersList.length;i++){
                if(this.passengersList[i].id===id){
                    this.passengersList[i].checked=false;
                }
            }
            this.theChangeSelectSessionStorage();
        },
        ticketReservation(){
            if(this.ticketIsRun===true){
                return;
            }
            if(this.name===''){
              this.thisMessage=`请输入联系人姓名`;
                this.windowShow=true;
                this.$refs['popup'].readyHide(()=>{this.windowShow=false;});
                return;
            }
            if(this.tel===''){
              this.thisMessage=`请输入联系人手机号`;
                this.windowShow=true;
                this.$refs['popup'].readyHide(()=>{this.windowShow=false;});
                return;
            }


            this.ticketIsRun=true;
            this.finishLoadShow=true;

            let passengers = [];
            for(let i=0;i<this.passengersListOther.length;i++){
              passengers.push({
                phone:this.passengersListOther[i].mobile,
                certType:this.passengersListOther[i].certType,//"身份证",//
                certNo:this.passengersListOther[i].idCard,
                name:this.passengersListOther[i].name,
                birthday:this.passengersListOther[i].birthday,
                sex:this.passengersListOther[i].sex
              })
            }

            let contact = {
                name:this.name,
                phone:this.tel
            }

            let params = {
              orderInfo: {
                supplierId: this.supplierId,
                orderQuantity: passengers.length,
                shouldPay: this.totalPublishPrice,
                innerTravelFlag: this.innerTravelFlag,
                originType: 2, // 订单来源(1.pc 2.微信)
              },
              flightInfo: {
                flightNum: this.flightNum,
                leaveTime: dayjs(this.leaveTime).format('YYYY-MM-DD HH:mm'),
                arriveTime: dayjs(this.arriveTime).format('YYYY-MM-DD HH:mm'),
                cabin: this.cabin,
                publishPrice: this.publishPrice,
                fromAirport: this.from,
                toAirport: this.to,
              },
              passengers,
              contact,
              bkInfo: {
                bookingTag: this.bookingTag,
                sys: this.sys,
              }
            };

            this.$API.flights.ticketReservation(params).then((res)=>{
                this.finishLoadShow=false;
                if(res.code===200){

                    // console.log('5555555')
                    this.thisMessage="订单已提交成功";
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                        let payParams={
                            orderNo:res.data.orderNo,
                            shouldPay:res.data.shouldPay,
                            productType:"3",
                            // goNumber:-3
                        };
                        sessionStorage.setItem('tempMainSelectPassenager','[]');
                        sessionStorage.setItem('tempPassengersListOther','{}');
                        sessionStorage.setItem('tempSelectPassenager','[]');
                        console.log('支付',JSON.stringify(payParams))
                        localStorage.setItem("testData",JSON.stringify(payParams));
                        this.$router.replace({
                            path: '/pay/pay'
                        });

                        // this.$router.push({
                        //     path:"./my-flights-order"
                        // })
                    })
                    localStorage.removeItem('check_param');
                    localStorage.removeItem('business_ext');
                }else{

                    // console.log('666666');
                    this.thisMessage="订单提交失败，"+res.msg;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                    })
                }

            })
            .catch(()=>{
                // console.log('77777777');
                this.finishLoadShow=false;
            })
            .finally(() => {
              this.ticketIsRun=false;
            })

        },
        setTempData(){

            sessionStorage.setItem('flights-passenger-add-data',JSON.stringify(this.$data));
            // sessionStorage.setItem('passenager-add-temp-data',JSON.stringify(this.$data))
        },
        getTempData(){
            this.goBack();
            // let tempData=sessionStorage.getItem('passenager-add-temp-data');
            // if(tempData!==null){
            //     let data=JSON.parse(tempData);
            //     for(let key in data){
            //         this.$data[key]=data[key];
            //     }
            //     // setTimeout(()=>{this.$forceUpdate;},100)
            // }
        },
        ticketShowMessage(){

            this.setTempData();
            this.$router.push({
                path: './ticket-change-message',
            })
        },
        handleJumping(url) {
          console.log('??????', url);
          window.location.href = url;
        },
        handleBlurContactItem(e, type) {
            var tempCruiseInputInfo = sessionStorage.getItem('flightContact') ? JSON.parse(sessionStorage.getItem('flightContact')) : {};
            if (e && e.target.value) {
                tempCruiseInputInfo[type] = e.target.value;  
            }
            sessionStorage.setItem('flightContact', JSON.stringify(tempCruiseInputInfo));
        },
    }
}
</script>
<style scoped>
    img{
        display: block;
    }
    .start-destination-class{
        width:100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom:0.5em;
    }
    .filghts-line-text{
        box-sizing: border-box;
        padding:0.25em 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #2E3033;
    }
    .img-clear-btn,.img-update-btn{
        padding:15px;
    }
    .img-clear-btn > img{
        width:20px;
        height:20px;
    }
    .img-update-btn > img {
        width:1em;
        height: 1em;
    }
    .button-div-border-red{
        height: 1.8rem;
        color:red;
        padding:0 1rem;
        border: 1px solid red;
        border-radius: 0.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: small;
        width:max-content;
    }
    .color-red{
        color:red;
    }
    .mess-tab{
        width: calc( ( 100vw - 40px - 45px - 8px ) / 4 );
        text-align: center;
        background: #F7F8FA;
        border-radius: 4px;
    }
    .mess-tab-name{
        font-size: small;
    }
    .mess-tab-ts{
        font-size: 11px;
        color: #3377FF;
        text-align: center;
    }
    .font-x-large{
        font-size: x-large;
    }
    .font-large{
        font-size: 15px;
        color: #2E3033;
    }
    .font-x-small{
        font-size: x-small;
    }
    .padding-div{
        padding:10px;
        width:100vw;
        box-sizing: border-box;
    }
     .flex{
        display: flex;
    }
     .jus-ite-center{
        justify-items: center;
    }
    .jus-ite-start{
        justify-items: flex-start;
    }
    .jus-ite-between{
        justify-items: space-between;
    }
    .jus-con-center{
        justify-content: center;
    }
    .jus-con-start{
        justify-content: flex-start;
    }
    .jus-con-between{
        justify-content: space-between;
    }
    .ali-ite-start{
        align-items: flex-start;
    }
    .ali-ite-center{
        align-items:center;
    }
    .ali-ite-end{
        align-items: flex-end;
    }
    .head-tab-div{
        background-color: #FFFFFF;
        border-radius: 10px;
        padding-bottom: 15px;
    }
    .my-body{
        background-image: url('../../../assets/flights/bg-img.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-color:#F4F6F9;
        padding: 10px 0 50px;
    }
    .content-padding{
        padding:0 15px;
        min-height:44px;
        box-sizing: border-box;
    }
    .head-child-div{
        background: linear-gradient(270deg, #FFFFFF 0%, #E6EEFF 100%);
    }
    .radius-top{
        border-radius: 10px 10px 0 0;
    }
    .radius-bottom{
        border-radius: 0 0 10px 10px;
    }
    .font-class{
        font-size: 13px;
        color: #3377FF;
    }
    .time-tab{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /* align-items: flex-start; */
        padding:12px 0;
    }
    .start-time{
        text-align: start;
        width:auto;
    }
    .arrive-time{
        text-align: start;
        width:auto;
    }
    .time-line-img{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }
    .time-line-img > img{
        width:4rem;
        margin: .5rem 1em;
    }
    .turn-to-stop {
      font-size: 12px;
      text-align: center;
      color: #8a8f99;
      line-height: 12px;
      height: 12px;
    }
    .color-2E3033{
        color: #2E3033;
    }
    .font-big{
        font-size:18px;
        font-weight: bold;
    }
    .head-next-price{
        color: #3C3F43;
        font-size: 14px;
    }
    .head-next-price > div::after {
        content: ' + ';
    }
    .head-next-price > div:last-child::after {
        content: '';
    }
    .head-next-price > div:first-child{
        margin-left: 0;
    }
    .head-next-price > div{
        margin-left: 5px;
    }
    .color-FF6861{
        color:#FF6861;
    }
    .flights-tab-end {
        display: flex;
        justify-content: start;
        align-items: center;
        color: #8A8F99;
        font-size: 11px;
    }
    .flights-tab-end > div {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right:1em;
    }
    .min-img-title{
        width:15px;
        height:15px;
        margin-right:0.25em;
    }

    .min-img-title-20{
        width:20px;
        height:20px;
        margin-right:0.25em;
    }
    .message-text-div{
        padding:15px;
        border-radius: 10px;
        background-color:white;
        margin-top:10px;
        color:#00CB8B;
        font-size:13px;
    }
    .border-div{
        border-radius:10px;
        background-color: white;
        overflow:hidden;
        padding:15px 0;
    }
    .margin-div{
        margin:0 15px;
    }
    .blue-border{
        width: calc( ( 100vw - 40px - 45px - 8px ) / 4 );
        /*4.3em;*/
        margin-right:10px;
        border-radius: 5px;
        border:1px solid #3377FF;
    }
    .mess-tab-other{
        width:100%;
    }
    .border-height{
        height: 60px;
        background: #F7F8FA;
        border:1px solid transparent;
    }
    .message-text{
        font-size: 12px;
        color: #ABB0BC;
        line-height: 1.3rem;
    }
    .color-blue{
        color:#3F9AFF;
    }
    .btn-blue{
        border: 1px solid #3377FF;
        background-color: #3377FF;
        border-radius: 4px;
        color:#FFFFFF;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:0 1em;
        width:max-content;
    }
    .bottom-btn-tab{
        position: fixed;
        left:0;
        bottom:0;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width:100vw;
        padding:10px;
        box-sizing: border-box;
        background: #FFFFFF;
        z-index: 199;
    }
    .price-show{
        font-size: 21px;
        font-weight: bold;
        color: #FF4D4D;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
    }
    .price-char{
        font-size: 12px;
        padding:0.25em;
        margin-right:0.25em;
    }
    .min-line-img{
        width:1em;
        margin:0 0.5em;
    }
    .tab-name{
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
    }
    .tab-type{
        font-size: 14px;
        color: #5C5F66;
        margin-left:8px;
    }
    .tab-idcard{
        font-size: 13px;
        color: #5C5F66;
        margin-top:5px;
    }
    .oneself-tab{
        font-size: 8px;
        font-weight: bold;
        color: #FF9933;
        border-radius: 2px;
        border: 1px solid #FF9933;
        padding:1px 3px;
        margin-left:10px;
    }
    .tab-update{
        width:50px;
        box-sizing: border-box;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #3377FF;
        font-size: 13px;
        color: #3377FF;
        margin-right:15px;
    }
    .margin-bottom{
        margin-bottom:20px;
    }
    .red-message{
        font-size: 12px;
        color: #FF4D4D;
        margin:0 10px;
        padding:0.5rem 0;
    }
    .red-message > span{
        margin-right:5px;
    }
    .mx-div{
        margin-right:30px;
    }
    .mx-show-text{
        font-size: 13px;
        font-weight: 500;
        color: #3377FF;
    }
    .mx-img{
        width:12px;
        height: 12px;
        margin-left:5px;
    }
    .bg-view-div{
        background:rgba(0,0,0,0.5);
        width:100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        position: fixed;
        left:0;
        bottom:0;
        z-index: 189;
    }
    .mx-body-div{
        background: #FFFFFF;
        border-radius: 10px 10px 0px 0px;
        width:100%;
        padding-bottom:50px;
        position: fixed;
        left:0;
        bottom:0;
        z-index: 190;
        height: 0;
        transition: height 1s,display 0.25s;
    }
    .mx-item-div{
        width: calc( 100% - 40px );
        margin:30px 20px;
        font-size: 15px;
        color: #2E3033;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mx-right-item{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .mx-price{
        font-size: 15px;
        font-weight: bold;
        color: #3377FF;
        width:50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .mx-num{
        font-size: 15px;
        color: #2E3033;
        width:50px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .message-top-div{
        width:100vw;
        height: 40px;
    }
    .float-message{
        width:100vw;
        height: 40px;
        box-sizing: border-box;
        font-size: 13px;
        color: #FF4D4D;
        background: #FFF2F2;
        display: flex;
        align-items: center;
        padding-left:20px;
        position: fixed;
        left:0;
        top:0;
    }
    .float-message > span {
        margin-right: 5px;
    }
    .margin-right-10{
        margin-right:10px;
    }
    .flights-img-logo{
        background:url(https://image.ganyoutong.cn/airline_icon.gif) no-repeat;

        display: inline-block;
        height: 24px;
        line-height: 26px;
        padding-left: 24px;
    }
    .row-four > div{
        margin-bottom:14px;
    }
    .row-four > div:nth-child(4n){
        margin-right: 0;
    }
    .new-fixed-palne{
        position: fixed;
        left:0;
        top:0;
        width:100vw;
        height: 100vh;
        z-index: 799;
    }
    .finish-load-class{
        position: fixed;
        top:0;
        left:0;
        width:100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        background: rgba(0,0,0,0.25);
    }
    .max-two-row{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-height: 25px;
        max-height: 25px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
